import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';

import {
  NotificationContainer,
  NotificationManager as N,
} from 'react-notifications';

import api from '../../../../services/api';
import {
  fileUploadImg,
  fileUploadInfluencerImg,
} from '../../../../services/s3';
import UserManagerContext from '../../UserManagerContext';

import ButtonLoader from '../../../../components/ButtonLoader';
import RatingView from '../../../../components/RatingView';

import 'react-notifications/lib/notifications.css';
import * as S from './styles';

const Image = ({ propData }) => {
  const { viewLoading, viewError, viewContent } = useContext(
    UserManagerContext
  );

  const [objDefault, setDefault] = useState({
    useThumbnailAvatar: 'https://cdn.profile.hkn-pro.com/square.png',
    useThumbnailBanner: 'https://cdn.profile.hkn-pro.com/banner.png',
  });
  const [objData, setData] = useState(propData);
  const [objTemp, setTemp] = useState({
    useThumbnailAvatar: objData.useThumbnailAvatar,
    useThumbnailBanner: objData.useThumbnailBanner,
  });
  // console.log(objData);

  const optStatus = [
    { id: 'Active', title: 'Active' },
    // { id: 'Processing', title: 'Processing' },
    { id: 'Disabled', title: 'Disabled' },
    // { id: 'Blocked', title: 'Blocked' },
  ];

  const handleCheckFiles = data => {
    console.log('#btn => Images -> Chek File');
    console.log(data);
  };

  const handleChangeFileAvatar = async img => {
    console.log('#useThumbnailAvatar => Upload -> Start');

    // console.log(img);
    try {
      const fileUpload = await fileUploadImg(
        'PROFILE',
        objData.useId,
        'avatar',
        img[0]
      );
      console.log(fileUpload);

      // Validate Resolutions
      const comImage = document.createElement('img');
      comImage.src = fileUpload.link;
      comImage.onload = function() {
        // console.log(comImage.naturalWidth, comImage.naturalHeight);

        if (comImage.naturalWidth !== 400 || comImage.naturalHeight !== 400) {
          N.error('Image', 'Incorrect resolution');
          return false;
        }

        setTemp(prevState => {
          return {
            ...prevState,
            useThumbnailAvatar: fileUpload.link,
          };
        });
        console.log('#useThumbnailAvatar => Upload -> End');
      };
    } catch (e) {
      console.error(e);
      console.log('#useThumbnailAvatar => Upload -> Error');
    }
  };

  const handleChangeFileBanner = async img => {
    console.log('#useThumbnailBanner => Upload -> Start');

    // console.log(img);
    try {
      const fileUpload = await fileUploadImg(
        'PROFILE',
        objData.useId,
        'banner',
        img[0]
      );
      console.log(fileUpload);

      // Validate Resolutions
      const comImage = document.createElement('img');
      comImage.src = fileUpload.link;
      comImage.onload = function() {
        // console.log(comImage.naturalWidth, comImage.naturalHeight);

        if (comImage.naturalWidth !== 1920 || comImage.naturalHeight !== 480) {
          N.error('Image', 'Incorrect resolution');
          return false;
        }

        setTemp(prevState => {
          return {
            ...prevState,
            useThumbnailBanner: fileUpload.link,
          };
        });
        console.log('#useThumbnailBanner => Upload -> End');
      };
    } catch (e) {
      console.error(e);
      console.log('#useThumbnailBanner => Upload -> Error');
    }
  };

  const handleSubmit = async data => {
    N.warning('Coming soon');
    // try {
    //   // viewLoading();
    //   const data = {
    //     useThumbnailAvatar: objTemp.useThumbnailAvatar,
    //     useThumbnailBanner: objTemp.useThumbnailBanner,
    //   };
    //   console.log(`Data PUT`, data);
    //   const resPutData = await api(
    //     'PUT',
    //     `/user/${objData.useId}/image`,
    //     data
    //   );
    //   console.log(resPutData);

    //   N.success('Successfully updated');

    //   setTimeout(() => {
    //     // history.push('/');
    //     // viewContent();
    //   }, 1000);

    // } catch (error) {
    //   console.error(error);
    //   N.error('Error updating');
    //   // viewContent();
    // }
  };

  return (
    <>
      <S.Form onSubmit={handleCheckFiles}>
        <S.DivInput propW="20%">
          <small>
            Avatar <small>400px x 400px</small>
          </small>
          <S.LabelInputImage htmlFor="file-avatar">
            <img
              src={objTemp.useThumbnailAvatar}
              alt="Thumbnail Avatar"
              onError={() =>
                setTemp(prevState => {
                  return {
                    ...prevState,
                    tmpThumbnailSquare: objDefault.useThumbnailAvatar,
                  };
                })
              }
            />
            <input
              id="file-avatar"
              type="file"
              accept="image/*"
              onChange={e => handleChangeFileAvatar(e.target.files)}
            />
          </S.LabelInputImage>
        </S.DivInput>
        <S.DivInput propW="80%">
          <small>
            Banner <small>1920px x 480px</small>
          </small>
          <S.LabelInputImage htmlFor="file-banner">
            <img
              src={objTemp.useThumbnailBanner}
              alt="Thumbnail Banner"
              onError={() =>
                setTemp(prevState => {
                  return {
                    ...prevState,
                    tmpThumbnailSquare: objDefault.useThumbnailBanner,
                  };
                })
              }
            />
            <input
              id="file-banner"
              type="file"
              accept="image/*"
              onChange={e => handleChangeFileBanner(e.target.files)}
            />
          </S.LabelInputImage>
        </S.DivInput>
      </S.Form>
      <S.Form onSubmit={handleSubmit}>
        <S.DivButton>
          <ButtonLoader propTitle="SAVE" propSpinner={false} />
        </S.DivButton>
      </S.Form>
      <NotificationContainer />
    </>
  );
};

Image.defaultProps = {
  propData: {},
};

Image.propTypes = {
  propData: PropTypes.object,
};

export default Image;
